<template>
  <div class="summaryPanel">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h4>
              <slot name="title">something</slot>
            </h4>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <slot name="body">nothing</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['anchor'],
};
</script>

<style></style>
